import { useQuery } from "react-query";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import { ONE_HOUR } from "../constants";

export const useListNews = () => {
  const listNews = () => reactQueryGet(internalApi.supportWidget.listNews());

  return useQuery(["news"], () => listNews(), {
    staleTime: ONE_HOUR,
    retry: false,
  });
};
